module.exports = __webpack_public_path__ + "img/openCampus.afdbb0dd.png";